import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=59870187&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=59870187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59870187",
  null
  
)

export default component.exports